import script from "./SnsUnlinkConfirm.vue?vue&type=script&lang=ts&setup=true"
export * from "./SnsUnlinkConfirm.vue?vue&type=script&lang=ts&setup=true"

import "./SnsUnlinkConfirm.vue?vue&type=style&index=0&id=350e143b&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2780876773/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-350e143b"]])

export default __exports__